import * as Sentry from '@sentry/react';
import identity from 'lodash/identity';
import qs from 'qs';

import { camelize, decamelize } from 'helpers/camelize';

import { hcAuthenticatedHeaders } from './authorization';
import { getJsonParseErrorClass, RequestTooLargeError } from './errors';

export const buildOpts = opts => ({
  headers: hcAuthenticatedHeaders(),
  credentials: 'same-origin',
  method: 'GET',
  ...opts,
});

export const handleResponse = async (
  response,
  transformResponse = identity,
  skipCamelize = false
) => {
  const responseBody = await response.text();

  if (!responseBody) return response;

  let parsedJson;

  try {
    if (skipCamelize) {
      parsedJson = JSON.parse(responseBody);
    } else {
      parsedJson = camelize(JSON.parse(responseBody));
    }
  } catch (error) {
    const errorClass = getJsonParseErrorClass(responseBody);
    try {
      if (errorClass === RequestTooLargeError) {
        Sentry.withScope(function (scope) {
          scope.setLevel('info');

          Sentry.captureException('Debugging RequestTooLargeError', {
            contexts: {
              'Provided Context': {
                cookie: document?.cookie,
                cookieLength: document?.cookie?.length,
                url: response.url,
                body: responseBody,
              },
            },
          });
        });
      }
    } catch {
      // noop
    }
    throw new errorClass(error, response, responseBody);
  }

  if (response.ok) parsedJson = transformResponse(parsedJson);

  return { ok: response.ok, status: response.status, ...parsedJson };
};

export const formatBody = (body, ignoreHashRegex = false) =>
  JSON.stringify(decamelize(body, ignoreHashRegex));

export const objectToQueryString = obj => qs.stringify(obj, { arrayFormat: 'brackets' });

export const parseQueryString = str => qs.parse(str, { ignoreQueryPrefix: true });
